import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type CreateGroupSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function CreateGroupSuccessModal({ isOpen, handleClose }: CreateGroupSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="create-group-success">
      <AcknowledgeModal
        result="positive"
        title={t('typography.groupCreatedTitle')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="create-group-success-modal-btn"
      >
        {t('typography.groupCreatedDescription')}
      </AcknowledgeModal>
    </Modal>
  )
}
